import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IProductionDetailLayout } from '../../../models/layout/production-detail-layout.model';
import { TransactionalDataFacade } from '../../../services/facades/external-data/transactional-data-facade';
import { ITransactionalDataState } from '../../../services/facades/external-data/transactional-data.state.model';
import { ISharedDataState } from '../../../services/facades/master-data/shared-data-state.model';
import { SharedDataFacade } from '../../../services/facades/master-data/shared-data.facade';
import { ProductionLayoutService } from '../../../services/production-layout.service';

@Component({
    templateUrl: './production-detail.page.html',
    styleUrls: [ './production-detail.page.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductionDetailPage implements OnInit, OnDestroy {

    public transactionalDataState$: Observable<ITransactionalDataState>;
    public sharedDataState$: Observable<ISharedDataState>;
    public layout: IProductionDetailLayout;
    private destroy$: Subject<void> = new Subject();

    constructor(private myTransactionalDataFacade: TransactionalDataFacade,
                private myActivatedRoute: ActivatedRoute,
                private mySharedDataFacade: SharedDataFacade,
                private myProductionLayoutService: ProductionLayoutService,
                private myRouter: Router) {
    }

    public ngOnInit(): void {
        this.myActivatedRoute.params.pipe(map(params => Number(params[ 'productionOrderNr' ])))
            .subscribe((productionOrderNr) => {
                void this.myTransactionalDataFacade.setSelectedProductionOrder(productionOrderNr);
            });

        this.layout = this.myProductionLayoutService.getProductionDetailLayout();
        this.transactionalDataState$ = this.myTransactionalDataFacade.subState();
        this.sharedDataState$ = this.mySharedDataFacade.subState();

        void Promise.all([
            firstValueFrom(this.mySharedDataFacade.fetchCostUnits()),
            firstValueFrom(this.mySharedDataFacade.fetchArticles()),
            firstValueFrom(this.mySharedDataFacade.fetchMeasureUnits()) ]);

    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public goBack(): void {
        void this.myRouter.navigate([ './..' ], {
            relativeTo: this.myActivatedRoute,
        });
    }
}
